import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    getUsers,
    setRow,
    setPage,
    removeUser,
    setTableConfig
} from "./actions";
import {
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Typography,
    IconButton,
    Button
} from "@material-ui/core";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import DeleteIcon from "@material-ui/icons/Delete";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
} from "reactstrap";
import { RemoveUserSnackbar, TableBodyCell, TableHeadCell } from "./Components";

const styles = () => ({
    tableWrapper: {
        overflowX: "auto"
    },
    table: {
        minWidth: 500
    },
});


class UserManagerTableDataWidget extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.setTableConfig(props.tableConfig);
        this.state = {
            removeUserModal: false,
            removingUser: false,
            removeUserInfo: {
                uid: "",
                name: ""
            }
        };
    }
    render() {
        const { users, row, page, setRow, setPage } = this.props;
        //const { classes } = this.props;
        return (
            <React.Fragment>
                {/* <Paper
                    style={{
                        width: "100%",
                        border: "1px solid black",
                        marginTop: 20,
                        marginBottom: 20
                    }}
                > */}
                    {users && (
                        // <div style={{ maxWidth : "100vw" }}>
                        <div className={styles.tableWrapper}>
                        <Table
                            className={styles.table}
                            padding="dense"
                            style={{ margin: 30, width: "95%" }}
                        >
                        <Paper
                            style={{
                                width: "100%",
                                border: "1px solid black",
                                marginTop: 20,
                                marginBottom: 20
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TablePagination
                                        colSpan={12}
                                        ActionsComponent={TablePaginationHelper}
                                        count={users.length}
                                        rowsPerPage={row}
                                        page={page}
                                        onChangePage={(event, page) =>
                                            setPage(page)
                                        }
                                        onChangeRowsPerPage={event =>
                                            setRow(event.target.value)
                                        }
                                        rowsPerPageOptions={[50, 100]}
                                    />
                                </TableRow>
                                <TableRow>
                                    <TableHeadCell text="User Name" />
                                    {this.props.tableConfig &&
                                        this.props.tableConfig.map(
                                            configInfo => {
                                                return (
                                                    <TableHeadCell
                                                        text={`${
                                                            configInfo.label
                                                        }`}
                                                        key={configInfo.key}
                                                    />
                                                );
                                            }
                                        )}
                                    <TableHeadCell text="Actions" />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users.map((user, i) => {
                                    return (
                                        <TableRow key={user.uid}>
                                            <TableBodyCell
                                                text={`${user.user_name}`}
                                            />
                                            {this.props.tableConfig &&
                                                this.props.tableConfig.map(
                                                    configInfo => {
                                                        return (
                                                            <TableBodyCell
                                                                text={
                                                                    user[
                                                                        configInfo
                                                                            .key
                                                                    ]
                                                                }
                                                                key={
                                                                    user.uid +
                                                                    configInfo.key
                                                                }
                                                            />
                                                        );
                                                    }
                                                )}
                                            <TableCell>
                                                <Link
                                                    to={`/user-profile-view/${
                                                        user.uid
                                                    }`}
                                                >
                                                    <IconButton
                                                        style={{
                                                            color: "indigo",
                                                            border:
                                                                "1px solid indigo",
                                                            marginRight: 10
                                                        }}
                                                    >
                                                        <ViewIcon />
                                                    </IconButton>
                                                </Link>
                                                <IconButton
                                                    onClick={() => {
                                                        this.setState({
                                                            removeUserModal: true,
                                                            removeUserInfo: {
                                                                uid: user.uid,
                                                                name: `${
                                                                    user.user_name
                                                                }`
                                                            }
                                                        });
                                                    }}
                                                    style={{
                                                        color: "red",
                                                        border: "1px solid red"
                                                    }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                            </Paper>
                        </Table>
                        </div>
                    )}
                {/* </Paper> */}
                <Modal isOpen={this.state.removeUserModal}>
                    <ModalHeader>Remove User</ModalHeader>
                    <ModalBody>
                        {!this.state.removingUser && (
                            <>
                                <Typography variant="body2">
                                    Are you you sure you want to remove user{" "}
                                    <b>{this.state.removeUserInfo.name}</b>?
                                </Typography>
                                <Typography variant="body2">
                                    This will only delete the user from
                                    accessing the website and app,{" "}
                                    <b>it will not delete this users reports</b>
                                </Typography>{" "}
                            </>
                        )}
                        {this.state.removingUser && (
                            <div style={{ width: 200, margin: "auto" }}>
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        marginRight: "25%",
                                        marginLeft: "25%"
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15
                                    }}
                                    variant="body2"
                                >
                                    Removing User, This Will Take a Moment
                                </Typography>
                            </div>
                        )}
                    </ModalBody>
                    {!this.state.removingUser && (
                        <ModalFooter>
                            <div>
                                <Button
                                    onClick={() =>
                                        this.setState({
                                            removeUserModal: false,
                                            removeUserInfo: {
                                                uid: "",
                                                name: ""
                                            }
                                        })
                                    }
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.props.removeUser(
                                            this.state.removeUserInfo.uid,
                                            success => {
                                                if (success === "removing") {
                                                    this.setState({
                                                        removingUser: true
                                                    });
                                                } else if (success === true) {
                                                    this.setState({
                                                        removeUserModal: false,
                                                        removingUser: false,
                                                        removeUserInfo: {
                                                            uid: "",
                                                            name: ""
                                                        },
                                                        removeSuccess: true
                                                    });
                                                } else
                                                    this.setState({
                                                        removeUserModal: false,
                                                        removingUser: false,
                                                        removeUserInfo: {
                                                            uid: "",
                                                            name: ""
                                                        },
                                                        removeFail: true
                                                    });
                                            }
                                        );
                                    }}
                                >
                                    Remove
                                </Button>
                            </div>
                        </ModalFooter>
                    )}
                </Modal>
                <RemoveUserSnackbar
                    removeFail={this.state.removeFail}
                    removeSuccess={this.state.removeSuccess}
                    setModalState={() =>
                        this.setState({
                            removeFail: false,
                            removeSuccess: false
                        })
                    }
                />
            </React.Fragment>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectUserInfo, selectPage, selectRow } = selectors;
            return {
                users: selectUserInfo(store),
                page: selectPage(store),
                row: selectRow(store)
            };
        },
        {
            getUsers,
            setRow,
            setPage,
            removeUser,
            setTableConfig
        }
    )(UserManagerTableDataWidget)
);
